import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stripeAfterPaymentToken: null,
};

const MiscSlice = createSlice({
    name: 'misc',
    initialState,
    reducers: {

        // store the token globally
        setStripeTokenGlobally: (state, action) => {

            return {
                ...state,
                stripeAfterPaymentToken: action?.payload
            }
        },

    },
});

export const { setStripeTokenGlobally } = MiscSlice.actions;
export default MiscSlice.reducer;
